import { StateCreator } from 'zustand';
import { devtools } from 'zustand/middleware';

export const devTools = (
  import.meta.env.MODE === 'development'
    ? (fn: StateCreator<any>, options?: any) => {
        const wrappedFn: StateCreator<any> = (set, get, api) => {
          let currentAction: { name: string; startTime: number } | null = null;

          const wrappedSet: typeof set = (...args: any[]) => {
            if (currentAction) {
              const elapsed = Math.round(performance.now() - currentAction.startTime);
              let actionObj = args[2];

              if (typeof actionObj === 'string') {
                actionObj = { type: actionObj, duration: elapsed };
              } else if (typeof actionObj === 'object' && actionObj !== null) {
                actionObj = { ...actionObj, duration: elapsed };
              } else {
                actionObj = { type: currentAction.name, duration: elapsed };
              }

              args[2] = actionObj;
            }

            return (set as any)(...args);
          };

          const state = fn(wrappedSet, get, api);

          const wrapActions = (obj: any, path: string[] = []): any => {
            if (typeof obj !== 'object' || obj === null) return obj;

            const newObj = Array.isArray(obj) ? [...obj] : { ...obj };

            Object.keys(newObj).forEach((key) => {
              const value = newObj[key];

              if (typeof value === 'function') {
                const actionName = path.length > 0 ? `${path.join('/')}/${key}` : key;

                newObj[key] = function (this: any, ...args: any[]) {
                  const prevAction = currentAction;
                  currentAction = { name: actionName, startTime: performance.now() };
                  try {
                    const res = value.apply(this, args);
                    if (res instanceof Promise) {
                      return res.finally(() => {
                        currentAction = prevAction;
                      });
                    }
                    currentAction = prevAction;
                    return res;
                  } catch (e) {
                    currentAction = prevAction;
                    throw e;
                  }
                };
              } else if (
                typeof value === 'object' &&
                value !== null &&
                !Array.isArray(value) &&
                (Object.getPrototypeOf(value) === Object.prototype || Object.getPrototypeOf(value) === null)
              ) {
                newObj[key] = wrapActions(value, [...path, key]);
              }
            });

            return newObj;
          };

          return wrapActions(state);
        };

        return devtools(wrappedFn, options);
      }
    : (fn: unknown) => fn
) as typeof devtools;
